exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inspection-dropdown-item[data-v-11127734] {\n  white-space: normal !important;\n  overflow: auto !important;\n  height: auto !important;\n  line-height: 22px !important;\n  padding: 8px 20px !important;\n}\n\n", ""]);

// exports
